<template>
    <g fill="none" fill-rule="evenodd">
        <g fill="white">
            <path d="M1125.064 3989.063l7.977-8.853c.254-.28.663-.28.917 0l7.977 8.853c.253.28.253.734 0 1.014l-1.056 1.17c-.26.286-.674.28-.922-.012l-5.05-5.793v14.842c0 .394-.292.716-.648.716h-1.509c-.356 0-.647-.322-.647-.716v-14.842l-5.05 5.793c-.254.286-.669.292-.922.011l-1.057-1.169c-.264-.28-.264-.734-.01-1.014zM1144.28 4004h-21.562c-.396 0-.719.312-.719.692v1.616c0 .38.323.692.719.692h21.562c.396 0 .719-.312.719-.692v-1.616c0-.38-.323-.692-.719-.692z" transform="translate(-1122 -3980)"/>
        </g>
    </g>
</template>

<script>
export default {
    name: 'uploadIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 23 27');
    }
};
</script>
